// Dependencies
import _ from 'lodash'; 
import styled, {css} from 'styled-components';
import { Helpers } from '../../utils';

// Types
import { Components } from "../../types";
 
// Components
import Icon from '../Icon';
import { InfoTooltip, ShippingInfoBox } from './ShippingInfoTooltip';

export const Availability = ({translations, product, ...props}: Components.ProductAvailability) => {
    
    return (
        <AvailabilityWrapper status={product.stockStatus}>
            <AvailabilityText stockStatus={product.stockStatus}>
                {product.stockStatus !== 'instock' &&
                    <Icon id={`stock_${product.stockStatus}`} {...props} />
                }
                <StockStatus>
                    {translations.stock[product.stockStatus]}
                </StockStatus>
            </AvailabilityText>
            { (product?.meta?.deliveryTime && props?.config?.general?.shippingInfo && product.available) &&
                <DeliveryTime>
                    <span>{`${product.meta.deliveryTime}`}</span>&nbsp;
                    <InfoTooltip label={props?.config?.general?.shippingInfo.label} icon="info">
                    {props.config.general.shippingInfo.content.map((infoBoxData: any, index: number) => <ShippingInfoBox key={`shipping-info-${index}`} {...{ ...infoBoxData, config: props.config }} />)}
                    </InfoTooltip>
                </DeliveryTime> 
            }
        </AvailabilityWrapper>
    )

}

export const AvailabilityWrapper = styled.div<any>(
({ status, theme: { general, components: {availability: style} } }) => css`
    display: flex;
    flex-direction: column;

    color: ${style.color[status]};
 
    svg {
        margin-right: .5em;
    }
`);

export const AvailabilityText = styled.span<any>(
({ stockStatus, theme: { general, components: {addToCartButton: style} } }) => css`
    display: flex;
    align-items: center;
    margin-bottom: 0.1em;
    color: currentColor;
    line-height: 1;
    svg {
        ${stockStatus !== 'instock' && `
            width: 2em;
            height: 2em;
        `}
    }
`);

export const StockStatus = styled.strong<any>(
({ theme: { general, components: {addToCartButton: style} } }) => css`
    color: currentColor;
    font-weight: 600;
    line-height: 1;
    ${Helpers.clamp('font-size', 1, 1.25, 2.5)};
`);

export const DeliveryTime = styled.small<any>(
({ theme: { general, components: {addToCartButton: style} } }) => css`
    color: currentColor;
    line-height: 1;
    margin-top: 0.25em;
    & > span {
        ${Helpers.clamp('font-size', 1, 1.15, 2.5)};
    } 
`);